// Shared web SPA locale state. Translation values are plain text, never HTML.
export const LOCALES = {
  "en": {
    "cowboyMode.label": "Cowboy-Coding mode",
    "cowboyMode.disabled": "Disabled",
    "cowboyMode.related": "Related Tasks Only",
    "cowboyMode.project": "Whole Project",
    "cowboyMode.hint": "After completion, starts fresh sessions for dependent tasks. Whole Project also continues remaining sprint work and later sprints. Bypass only.",
    "cowboyMode.refused": "Cowboy mode was disabled because this task no longer runs in Bypass mode. Reopen it to refresh its permission mode.",
    "nav.workspace": "Workspace",
    "nav.dashboard": "Dashboard",
    "nav.project": "Project",
    "nav.admin": "Admin",
    "nav.board": "Board",
    "nav.epics": "Epics",
    "nav.backlog": "Backlog",
    "nav.planning": "Planning",
    "nav.insights": "Insights",
    "nav.serverAgent": "Server Agent",
    "nav.settings": "Settings",
    "nav.allTasks": "All Tasks",
    "sidebar.allProjects": "All Projects",
    "sidebar.scope": "All Projects or project",
    "sidebar.newProject": "+ New Project…",
    "sidebar.openTab": "Open in New Tab",
    "sidebar.openProjectTab": "Open {name} in new tab",
    "sidebar.toggle": "Toggle sidebar",
    "sidebar.expand": "Expand sidebar",
    "sidebar.collapse": "Collapse sidebar",
    "navbar.toggleMenu": "Toggle menu",
    "navbar.install": "Install app",
    "navbar.notifications": "Notifications",
    "navbar.profile": "Profile",
    "navbar.security": "Security",
    "navbar.logout": "Logout",
    "navbar.theme": "Light / dark",
    "navbar.toggleTheme": "Toggle light or dark mode",
    "twofa.region": "Two-factor authentication recommendation",
    "twofa.heading": "Protect your account with 2FA",
    "twofa.body": "Recommended for password sign-in. Google sign-in already stays separate and does not require this.",
    "twofa.enable": "Enable 2FA",
    "twofa.dismissLabel": "Dismiss 2FA recommendation",
    "common.dismiss": "Dismiss",
    "status.pending": "Pending",
    "status.in_progress": "In Progress",
    "status.on_fire": "On Fire",
    "status.completed": "Completed",
    "status.canceled": "Canceled",
    "nav.planning.sprints": "Sprints Planning",
    "nav.planning.batches": "Batches Planning",
    "nav.planning.bags": "Bags Planning",
    "nav.planning.jars": "Jars Planning",
    "nav.planning.groups": "Groups Planning",
    "nav.planning.steps": "Steps Planning",
    "nav.planning.sprint": "Sprint Planning"
  },
  "uk": {
    "cowboyMode.label": "Ковбойський режим",
    "cowboyMode.disabled": "Вимкнено",
    "cowboyMode.related": "Лише пов’язані завдання",
    "cowboyMode.project": "Увесь проєкт",
    "cowboyMode.hint": "Після завершення запускає нові сесії для залежних завдань. Увесь проєкт також продовжує роботу в поточному й наступних спринтах. Лише без підтверджень.",
    "cowboyMode.refused": "Ковбойський режим вимкнено, оскільки завдання більше не працює без підтверджень. Відкрийте його знову, щоб оновити режим дозволів.",
    "nav.workspace": "Робочий простір",
    "nav.dashboard": "Огляд",
    "nav.project": "Проєкт",
    "nav.admin": "Адміністрування",
    "nav.board": "Дошка",
    "nav.epics": "Епіки",
    "nav.backlog": "Беклог",
    "nav.planning": "Планування",
    "nav.insights": "Аналітика",
    "nav.serverAgent": "Серверний агент",
    "nav.settings": "Налаштування",
    "nav.allTasks": "Усі завдання",
    "sidebar.allProjects": "Усі проєкти",
    "sidebar.scope": "Усі проєкти або окремий проєкт",
    "sidebar.newProject": "+ Новий проєкт…",
    "sidebar.openTab": "Відкрити в новій вкладці",
    "sidebar.openProjectTab": "Відкрити {name} в новій вкладці",
    "sidebar.toggle": "Перемкнути бічну панель",
    "sidebar.expand": "Розгорнути бічну панель",
    "sidebar.collapse": "Згорнути бічну панель",
    "navbar.toggleMenu": "Перемкнути меню",
    "navbar.install": "Встановити застосунок",
    "navbar.notifications": "Сповіщення",
    "navbar.profile": "Профіль",
    "navbar.security": "Безпека",
    "navbar.logout": "Вийти",
    "navbar.theme": "Світла / темна",
    "navbar.toggleTheme": "Перемкнути світлий або темний режим",
    "twofa.region": "Рекомендація щодо двофакторної автентифікації",
    "twofa.heading": "Захистіть обліковий запис за допомогою 2FA",
    "twofa.body": "Рекомендовано для входу за паролем. Вхід через Google працює окремо й не потребує цього налаштування.",
    "twofa.enable": "Увімкнути 2FA",
    "twofa.dismissLabel": "Закрити рекомендацію щодо 2FA",
    "common.dismiss": "Закрити",
    "status.pending": "Очікує",
    "status.in_progress": "В роботі",
    "status.on_fire": "Термінове",
    "status.completed": "Виконано",
    "status.canceled": "Скасовано",
    "nav.planning.sprints": "Планування спринтів",
    "nav.planning.batches": "Планування партій",
    "nav.planning.bags": "Планування сумок",
    "nav.planning.jars": "Планування банок",
    "nav.planning.groups": "Планування груп",
    "nav.planning.steps": "Планування кроків",
    "nav.planning.sprint": "Планування спринтів"
  },
  "zh": {
    "cowboyMode.label": "牛仔编程模式",
    "cowboyMode.disabled": "已禁用",
    "cowboyMode.related": "仅关联任务",
    "cowboyMode.project": "整个项目",
    "cowboyMode.hint": "完成后为依赖任务启动新会话。整个项目还会继续当前及后续迭代中的任务。仅限免确认模式。",
    "cowboyMode.refused": "此任务不再使用免确认模式，因此牛仔模式已禁用。请重新打开任务以刷新权限模式。",
    "nav.workspace": "工作区",
    "nav.dashboard": "概览",
    "nav.project": "项目",
    "nav.admin": "管理",
    "nav.board": "看板",
    "nav.epics": "史诗",
    "nav.backlog": "待办列表",
    "nav.planning": "规划",
    "nav.insights": "分析",
    "nav.serverAgent": "服务器智能体",
    "nav.settings": "设置",
    "nav.allTasks": "所有任务",
    "sidebar.allProjects": "所有项目",
    "sidebar.scope": "所有项目或单个项目",
    "sidebar.newProject": "+ 新建项目…",
    "sidebar.openTab": "在新标签页中打开",
    "sidebar.openProjectTab": "在新标签页中打开 {name}",
    "sidebar.toggle": "切换侧边栏",
    "sidebar.expand": "展开侧边栏",
    "sidebar.collapse": "收起侧边栏",
    "navbar.toggleMenu": "切换菜单",
    "navbar.install": "安装应用",
    "navbar.notifications": "通知",
    "navbar.profile": "个人资料",
    "navbar.security": "安全",
    "navbar.logout": "退出登录",
    "navbar.theme": "浅色 / 深色",
    "navbar.toggleTheme": "切换浅色或深色模式",
    "twofa.region": "双重身份验证建议",
    "twofa.heading": "使用双重身份验证保护账户",
    "twofa.body": "建议为密码登录启用此功能。Google 登录采用独立流程，无需此设置。",
    "twofa.enable": "启用双重身份验证",
    "twofa.dismissLabel": "关闭双重身份验证建议",
    "common.dismiss": "关闭",
    "status.pending": "待处理",
    "status.in_progress": "进行中",
    "status.on_fire": "紧急",
    "status.completed": "已完成",
    "status.canceled": "已取消",
    "nav.planning.sprints": "迭代规划",
    "nav.planning.batches": "批次规划",
    "nav.planning.bags": "袋规划",
    "nav.planning.jars": "罐规划",
    "nav.planning.groups": "分组规划",
    "nav.planning.steps": "步骤规划",
    "nav.planning.sprint": "迭代规划"
  },
  "es": {
    "cowboyMode.label": "Modo de programación vaquera",
    "cowboyMode.disabled": "Desactivado",
    "cowboyMode.related": "Solo tareas relacionadas",
    "cowboyMode.project": "Todo el proyecto",
    "cowboyMode.hint": "Al completar, inicia sesiones nuevas para tareas dependientes. Todo el proyecto continúa también con el trabajo del sprint actual y los siguientes. Solo sin confirmación.",
    "cowboyMode.refused": "El modo vaquero se desactivó porque esta tarea ya no se ejecuta sin confirmación. Ábrela de nuevo para actualizar sus permisos.",
    "nav.workspace": "Espacio de trabajo",
    "nav.dashboard": "Panel de control",
    "nav.project": "Proyecto",
    "nav.admin": "Administración",
    "nav.board": "Tablero",
    "nav.epics": "Épicas",
    "nav.backlog": "Trabajo pendiente",
    "nav.planning": "Planificación",
    "nav.insights": "Análisis",
    "nav.serverAgent": "Agente de servidor",
    "nav.settings": "Configuración",
    "nav.allTasks": "Todas las tareas",
    "sidebar.allProjects": "Todos los proyectos",
    "sidebar.scope": "Todos los proyectos o un proyecto",
    "sidebar.newProject": "+ Nuevo proyecto…",
    "sidebar.openTab": "Abrir en una pestaña nueva",
    "sidebar.openProjectTab": "Abrir {name} en una pestaña nueva",
    "sidebar.toggle": "Alternar barra lateral",
    "sidebar.expand": "Expandir barra lateral",
    "sidebar.collapse": "Contraer barra lateral",
    "navbar.toggleMenu": "Alternar menú",
    "navbar.install": "Instalar aplicación",
    "navbar.notifications": "Notificaciones",
    "navbar.profile": "Perfil",
    "navbar.security": "Seguridad",
    "navbar.logout": "Cerrar sesión",
    "navbar.theme": "Claro / oscuro",
    "navbar.toggleTheme": "Alternar modo claro u oscuro",
    "twofa.region": "Recomendación de autenticación de dos factores",
    "twofa.heading": "Protege tu cuenta con la autenticación de dos factores",
    "twofa.body": "Se recomienda para el inicio de sesión con contraseña. El inicio de sesión con Google es independiente y no requiere esta configuración.",
    "twofa.enable": "Activar autenticación de dos factores",
    "twofa.dismissLabel": "Cerrar recomendación de autenticación de dos factores",
    "common.dismiss": "Cerrar",
    "status.pending": "Pendiente",
    "status.in_progress": "En curso",
    "status.on_fire": "Urgente",
    "status.completed": "Completado",
    "status.canceled": "Cancelado",
    "nav.planning.sprints": "Planificación de sprints",
    "nav.planning.batches": "Planificación de lotes",
    "nav.planning.bags": "Planificación de bolsas",
    "nav.planning.jars": "Planificación de frascos",
    "nav.planning.groups": "Planificación de grupos",
    "nav.planning.steps": "Planificación de pasos",
    "nav.planning.sprint": "Planificación de sprints"
  }
};

let locale = 'en';
const listeners = new Set();

export function setLocale(language) {
  const next = Object.hasOwn(LOCALES, language) ? language : 'en';
  if (next === locale) return;
  locale = next;
  for (const listener of listeners) listener(locale);
}

export function getLocale() { return locale; }

export function subscribeLocale(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function hasTranslation(key) { return Object.hasOwn(LOCALES.en, key); }

export function t(key, params = {}) {
  const table = LOCALES[locale];
  const value = (Object.hasOwn(table, key) ? table[key] : undefined)
    ?? (hasTranslation(key) ? LOCALES.en[key] : key);
  return String(value).replace(/\{(\w+)\}/g, (match, name) =>
    Object.hasOwn(params, name) ? String(params[name]) : match);
}

// Refresh text/accessible labels in place, preserving controls and event handlers.
export function translateElements(root) {
  if (!root) return;
  for (const attr of ['text', 'title', 'aria-label']) {
    for (const el of root.querySelectorAll(`[data-i18n-${attr}]`)) {
      const value = t(el.getAttribute(`data-i18n-${attr}`));
      if (attr === 'text') el.textContent = value;
      else el.setAttribute(attr, value);
    }
  }
}
